import { Backdrop as BackdropMUI, styled } from '@mui/material'

const Backdrop = styled(BackdropMUI)(({ theme }) => ({
  zIndex: theme.zIndex.modal + 1,
}))

export default Backdrop
